<template>
  <div>
    <el-dialog
      v-if="show"
      title="风险评估工具"
      :visible.sync="show"
      ref="dialogForm"
      width="700px"
      top="6vh">
      <div style="height: 500px">
        <b >请选择任意一种判定方法：</b>
          <div class="display-flex ai-center jc-space-between mb-20 pb-10 mt-20">
            <div @click="form.active = '1'" class="mr-10 level-box" :class="{'level-box-active': form.active === '1'}">
              <p class="margin-0">直接判断法</p>
              <div class="triangle" v-if="form.active === '1'"></div>
            </div>
            <div @click="form.active = '2'" class="mr-10 level-box" :class="{'level-box-active': form.active === '2'}">
              <p class="margin-0">风险矩阵分析法</p>
              <p class="margin-0 mt-6 fs-12">（LS法）</p>
              <div class="triangle" v-if="form.active === '2'"></div>
            </div>
            <div @click="form.active = '3'" class="level-box" :class="{'level-box-active': form.active === '3'}">
              <p class="margin-0">作业条件危险性分析法</p>
              <p class="margin-0 mt-6 fs-12">（LEC法）</p>
              <div class="triangle" v-if="form.active === '3'"></div>
            </div>
          </div>
          <div v-if="form.active === '1'">
            <b>请选择风险等级：</b>
            <div class="level-list">
              <div
                v-for="item in form.method1Option"
                :key="item.id" class="item"
                @click="form.method1Value = item.id">
                <el-radio v-model="form.method1Value" :label="item.id"><span></span></el-radio>
                <p
                  :style="{background: levelColor(item.id)}"
                  style="position:relative;left: -20px;width: 80px;"
                  class="margin-0 padding-10 ta-center color-white br-2">
                  {{item.id | levelName}}
                </p>
                <p style="color: #666666">{{ item.description }}</p>
              </div>
            </div>
          </div>
          <div v-if="form.active === '2'">
            <b>请选择对应数值：</b>
            <div class="table">
              <header>
                <div class="flex-1 display-flex ai-center jc-space-between" style="padding: 0 30px">
                  <p class="width-60 ta-center">
                    L <i class="el-icon-question color-info cursor-pointer ml-6"></i>
                  </p>
                  <p class="width-20 ta-center">
                    *
                  </p>
                  <p class="width-60 ta-center">
                    S <i class="el-icon-question color-info cursor-pointer ml-6"></i>
                  </p>
                  <p class="width-20 ta-center">
                    =
                  </p>
                  <p class="width-60 ta-center">
                    R
                  </p>
                </div>
                <div class="width-100 pl-20 pr-20 height-percent-100 display-flex ai-center jc-center" style="border-left: 1px solid #E6E6E6">
                  对应风险等级
                </div>
              </header>
              <div class="row">
                <div class="flex-1 display-flex ai-center jc-space-between" style="padding: 0 30px">
                  <div class="width-60 ta-center">
                    <el-popover
                      v-model="form.method2.popoverL"
                      placement="bottom"
                      trigger="click">
                      <div>
                        <header class="display-flex ai-center jc-space-between">
                          <b class="fs-12">设置L值等级</b>
                          <i class="el-icon-close cursor-pointer" @click="form.method2.popoverL = false"></i>
                        </header>
                        <el-table
                          @row-click="(e) => form.method2.L = e.level"
                          class="mt-12 cursor-pointer"
                          size="mini"
                          :data="form.method2.popoverLData">
                          <el-table-column
                            align="center"
                            prop="level"
                            label="等级"
                            width="100">
                            <template #default="slotProps">
                              <el-radio v-model="form.method2.L" :label="slotProps.row.level"><span></span></el-radio>
                              <b style="position: relative;left: -26px">{{slotProps.row.level}}</b>
                            </template>
                          </el-table-column>
                          <el-table-column
                            width="300"
                            prop="text">
                            <template #header>
                              <div class="display-flex ai-center jc-center">
                                判定条件
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <el-link slot="reference" type="primary">{{ form.method2.L || '设置' }}</el-link>
                    </el-popover>
                  </div>
                  <div class="width-20 ta-center"></div>
                  <div class="width-60 ta-center">
                    <el-popover
                      v-model="form.method2.popoverS"
                      placement="bottom"
                      trigger="click">
                      <div>
                        <header class="display-flex ai-center jc-space-between">
                          <b class="fs-12">设置S值等级</b>
                          <i class="el-icon-close cursor-pointer" @click="form.method2.popoverS = false"></i>
                        </header>
                        <el-table
                          @row-click="(e) => form.method2.S = e.level"
                          class="mt-12 cursor-pointer"
                          size="mini"
                          :data="form.method2.popoverSData">
                          <el-table-column
                            align="center"
                            prop="level"
                            label="等级"
                            width="100">
                            <template #default="slotProps">
                              <el-radio v-model="form.method2.S" :label="slotProps.row.level"><span></span></el-radio>
                              <b style="position: relative;left: -26px">{{slotProps.row.level}}</b>
                            </template>
                          </el-table-column>
                          <el-table-column
                            width="300"
                            prop="text">
                            <template #header>
                              <div class="display-flex ai-center jc-center">
                                判定条件
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <el-link slot="reference" type="primary">{{ form.method2.S || '设置' }}</el-link>
                    </el-popover>
                  </div>
                  <div class="width-20 ta-center"></div>
                  <div class="width-60 ta-center">
                    <p>{{LS || '------'}}</p>
                  </div>
                </div>
                <div class="width-100 pl-20 pr-20 height-percent-100 display-flex ai-center jc-center" style="border-left: 1px solid #E6E6E6">
                  <div v-if="LS" class="color-white padding-10 width-100 br-4 ta-center" :style="{background: LSColor}">
                    {{LSName}}
                  </div>
                  <span v-else>------</span>
                </div>
              </div>
            </div>
    <!--        <img  src="@/assets/images/LS.png" width="510px" class="mt-10" alt="">-->
          </div>
          <div v-if="form.active === '3'">
        <b>请选择对应数值：</b>
        <div class="table">
          <header>
            <div class="flex-1 display-flex ai-center jc-space-between" style="padding: 0 30px">
              <p class="width-60 ta-center">
                L <i class="el-icon-question color-info cursor-pointer ml-6"></i>
              </p>
              <p class="width-20 ta-center">
                *
              </p>
              <p class="width-60 ta-center">
                E <i class="el-icon-question color-info cursor-pointer ml-6"></i>
              </p>
              <p class="width-20 ta-center">
                *
              </p>
              <p class="width-60 ta-center">
                C <i class="el-icon-question color-info cursor-pointer ml-6"></i>
              </p>
              <p class="width-20 ta-center">
                =
              </p>
              <p class="width-60 ta-center">
                D
              </p>
            </div>
            <div class="width-100 pl-20 pr-20 height-percent-100 display-flex ai-center jc-center" style="border-left: 1px solid #E6E6E6">
              对应风险等级
            </div>
          </header>
          <div class="row">
            <div class="flex-1 display-flex ai-center jc-space-between" style="padding: 0 30px">
              <div class="width-60 ta-center">
                <el-popover
                  v-model="form.method3.popoverL"
                  placement="bottom"
                  trigger="click">
                  <div>
                    <header class="display-flex ai-center jc-space-between">
                      <b class="fs-12">设置L的分值</b>
                      <i class="el-icon-close cursor-pointer" @click="form.method3.popoverL = false"></i>
                    </header>
                    <el-table
                      @row-click="(e) => form.method3.L = e.level"
                      class="mt-12 cursor-pointer"
                      size="mini"
                      :data="form.method3.popoverLData">
                      <el-table-column
                        align="center"
                        prop="level"
                        label="分值"
                        width="100">
                        <template #default="slotProps">
                          <el-radio v-model="form.method3.L" :label="slotProps.row.level"><span></span></el-radio>
                          <b style="position: relative;left: -26px">{{slotProps.row.level}}</b>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="300"
                        prop="text">
                        <template #header>
                          <div class="display-flex ai-center jc-center">
                            事故发生的可能性
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <el-link slot="reference" type="primary">{{ form.method3.L || '设置' }}</el-link>
                </el-popover>
              </div>
              <div class="width-20 ta-center"></div>
              <div class="width-60 ta-center">
                <el-popover
                  v-model="form.method3.popoverE"
                  placement="bottom"
                  trigger="click">
                  <div>
                    <header class="display-flex ai-center jc-space-between">
                      <b class="fs-12">设置E的分值</b>
                      <i class="el-icon-close cursor-pointer" @click="form.method3.popoverE = false"></i>
                    </header>
                    <el-table
                      @row-click="(e) => form.method3.E = e.level"
                      class="mt-12 cursor-pointer"
                      size="mini"
                      :data="form.method3.popoverEData">
                      <el-table-column
                        align="center"
                        prop="level"
                        label="分值"
                        width="100">
                        <template #default="slotProps">
                          <el-radio v-model="form.method3.E" :label="slotProps.row.level"><span></span></el-radio>
                          <b style="position: relative;left: -26px">{{slotProps.row.level}}</b>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="300"
                        prop="text">
                        <template #header>
                          <div class="display-flex ai-center jc-center">
                            事故发生的可能性
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <el-link slot="reference" type="primary">{{ form.method3.E || '设置' }}</el-link>
                </el-popover>
              </div>
              <div class="width-20 ta-center"></div>
              <div class="width-60 ta-center">
                <el-popover
                  v-model="form.method3.popoverC"
                  placement="bottom"
                  trigger="click">
                  <div>
                    <header class="display-flex ai-center jc-space-between">
                      <b class="fs-12">设置C的分值</b>
                      <i class="el-icon-close cursor-pointer" @click="form.method3.popoverC = false"></i>
                    </header>
                    <el-table
                      @row-click="(e) => form.method3.C = e.level"
                      class="mt-12 cursor-pointer"
                      size="mini"
                      :data="form.method3.popoverCData">
                      <el-table-column
                        align="center"
                        prop="level"
                        label="分值"
                        width="100">
                        <template #default="slotProps">
                          <el-radio v-model="form.method3.C" :label="slotProps.row.level"><span></span></el-radio>
                          <b style="position: relative;left: -26px">{{slotProps.row.level}}</b>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="300"
                        prop="text">
                        <template #header>
                          <div class="display-flex ai-center jc-center">
                            事故发生的可能性
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <el-link slot="reference" type="primary">{{ form.method3.C || '设置' }}</el-link>
                </el-popover>
              </div>
              <div class="width-20 ta-center"></div>
              <div class="width-60 ta-center">
                <p>{{LEC || '------'}}</p>
              </div>
            </div>
            <div class="width-100 pl-20 pr-20 height-percent-100 display-flex ai-center jc-center" style="border-left: 1px solid #E6E6E6">
              <div v-if="LEC" class="color-white padding-10 width-100 br-4 ta-center" :style="{background: LECColor}">
                {{LECName}}
              </div>
              <span v-else>------</span>
            </div>
          </div>
        </div>

      </div>

      </div>
      <template #footer>
        <el-button type="primary" @click="submitForm" :loading="loading">确认</el-button>
        <el-button @click="$emit('close')">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'AssesstoolDialog',
  components: { },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      form: {
        active: '1', // 评估方法
        method1Value: null, // 直接判断法
        method1Option: [],
        method2: {
          L: null,
          S: null,
          popoverL: false,
          popoverLData: [],
          popoverS: false,
          popoverSData: [],
          popoverLSData: []

        }, // LS
        method3: {
          L: null,
          E: null,
          C: null,
          popoverL: false,
          popoverLData: [],
          popoverE: false,
          popoverEData: [],
          popoverC: false,
          popoverCData: [],
          popoverLECData: []
        } // LEC
      }
    }
  },
  filters: {
    levelName (val) {
      switch (val) {
        case '4':
          return '重大风险'
        case '3':
          return '较大风险'
        case '2':
          return '一般风险'
        case '1':
          return '低风险'
      }
    }
  },
  computed: {
    LS () {
      let LS = ''
      if (this.form.method2.L && this.form.method2.S) {
        LS = this.form.method2.L * this.form.method2.S.toFixed(2)
      }
      return LS
    },
    LSColor () {
      let color = ''
      const num1 = this.form.method2.popoverLSData[3].level[3]
      const num2 = this.form.method2.popoverLSData[2].level[3]
      const num3 = this.form.method2.popoverLSData[1].level[3]
      if (this.LS <= num1) {
        color = '#328FFF'
      } else if (this.LS <= num2) {
        color = '#F9E14A'
      } else if (this.LS <= num3) {
        color = '#FF822A'
      } else {
        color = '#FF4A4A'
      }
      return color
    },
    LSName () {
      let name = ''
      if (this.LS < 5) {
        name = '低风险'
      } else if (this.LS < 10) {
        name = '一般风险'
      } else if (this.LS < 17) {
        name = '较大风险'
      } else {
        name = '重大风险'
      }
      return name
    },
    LEC () {
      let LEC = ''
      if (this.form.method3.L && this.form.method3.E && this.form.method3.C) {
        LEC = this.form.method3.L * this.form.method3.E * this.form.method3.C.toFixed(2)
      }
      return LEC
    },
    LECColor () {
      const num1 = this.form.method3.popoverLECData[0].level.split(',')[0].split('(')[1]
      const num2 = this.form.method3.popoverLECData[1].level.split(',')[0].split('[')[1]
      const num3 = this.form.method3.popoverLECData[2].level.split(',')[0].split('[')[1]
      let color = ''
      if (this.LEC < num3) {
        color = '#328FFF'
      } else if (this.LEC < num2) {
        color = '#F9E14A'
      } else if (this.LEC < num1) {
        color = '#FF822A'
      } else {
        color = '#FF4A4A'
      }
      return color
    },
    LECName () {
      let name = ''
      if (this.LEC < 70) {
        name = '低风险'
      } else if (this.LEC < 160) {
        name = '一般风险'
      } else if (this.LEC < 320) {
        name = '较大风险'
      } else {
        name = '重大风险'
      }
      return name
    }
  },
  watch: {},
  methods: {
    /**
     * 风险等级对应颜色
     * @param id
     * @returns {string}
     */
    levelColor (id) {
      switch (id) {
        case '4':
          return '#FF4A4A'
        case '3':
          return '#F6B300'
        case '2':
          return '#F9E14A'
        case '1':
          return '#326BFF'
      }
    },
    /**
     * 风险等级文字转code
     * @param name
     * @returns {string}
     */
    levelName2Code (name) {
      switch (name) {
        case '低风险':
          return '1'
        case '一般风险':
          return '2'
        case '较大风险':
          return '3'
        case '重大风险':
          return '4'
      }
    },
    submitForm () {
      let data = null
      switch (this.form.active) {
        case '1': // 直接判断法
          if (!this.form.method1Value) {
            return this.$message.warning('请选择风险等级')
          }
          data = {
            type: '1',
            level: this.form.method1Value
          }
          break
        case '2': // LS法
          if (!this.LS) {
            return this.$message.warning('选择对应数值')
          }
          data = {
            type: '2',
            level: this.levelName2Code(this.LSName),
            L: this.form.method2.L,
            S: this.form.method2.S,
            R: this.LS
          }
          break
        case '3': // LEC法
          if (!this.LEC) {
            return this.$message.warning('选择对应数值')
          }
          data = {
            type: '3',
            level: this.levelName2Code(this.LECName),
            L: this.form.method3.L,
            E: this.form.method3.E,
            C: this.form.method3.C,
            D: this.LEC
          }
          break
      }
      console.log(data)
      this.$emit('getSelMethod', data)
    }
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.$api.riskLibrary.getRiskAssessList().then(res => {
      this.form.method1Option = JSON.parse(res[0].content)
      this.form.method2.popoverLData = JSON.parse(res[1].content).L
      this.form.method2.popoverSData = JSON.parse(res[1].content).S
      this.form.method2.popoverLSData = JSON.parse(res[1].content).R
      this.form.method3.popoverLData = JSON.parse(res[2].content).L
      this.form.method3.popoverEData = JSON.parse(res[2].content).E
      this.form.method3.popoverCData = JSON.parse(res[2].content).C
      this.form.method3.popoverLECData = JSON.parse(res[2].content).D
    })
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.level-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #E2E2E2;
  background-color: #F5F5F5 ;
  cursor: pointer;
}
.level-box-active {
  border: 1px solid #1774FF;
  background-color:#1774FF;
  color: #FFFFFF;
}

.level-list {
  margin-top: 16px;
  .item {
    border-radius: 4px;
    border: 1px solid #E6E6E6;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
.table {
  margin-top: 16px;
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  header {
    display: flex;
    align-items: center;
    background-color: #F3F3F6;
    border-bottom:  1px solid #E6E6E6;
    font-weight: 500;
    height: 40px;
  }
  .row {
    display: flex;
    align-items: center;
    font-weight: 500;
    height: 54px;
  }
}
::v-deep tbody {
  .el-table__cell {
    padding: 0;
  }
  .no-padding {
    .cell {
      padding: 0;
    }
  }
}

</style>
